import { Component, OnInit, NgModule, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, FormArray, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { SelectItem, MessageService } from 'primeng/api';
import { SidebarModule } from 'primeng/sidebar';
import { NgxSpinnerService } from 'ngx-spinner'
import { UserService } from '../../../../framework/services/userservice';
import { CommonService } from '../../../../framework/services/common.service';
import { LogoManagementService } from '../../../../framework/services/logo-mgmt.service';
import { EditEngagementMemoryServiceService } from '../../edit-engagement-memory-service/edit-engagement-memory-service.service';
import { of } from 'rxjs';
import { ConfirmationService } from 'primeng/api';
import { LanguageService } from 'src/framework/services/language.service';
import { CategoryConstant } from 'src/app/shared/app-constants/category-constants';
import { filter } from 'lodash';


@Component({
  selector: 'app-contacts-edit',
  templateUrl: './contacts-edit.component.html',
  styleUrls: ['./contacts-edit.component.css']
})

@NgModule({
  imports: [
    SidebarModule,
  ],
  declarations: [],
  providers: []
})
export class ContactsEditComponent implements OnInit {
  editing = true;
  emailList: any = [];
  selectedLanguages: any[] = [];

  displayInternalUserDropDown = true;
  isSaveButtonEnable: boolean = true;

  //internal Contacts
  internalContactColumns: any[];
  internalContactsTableData: any[] = [];
  internalContactModel: InternalUserModel;
  clonedInternalContact: InternalUserModel;
  userDropDownData: any = [];
  userRoles = [];
  internalContactRowIndex: number = 0;
  editInternalContactRowIdex: number = -1;

  //externalContactsRoles
  externalRoleColumns: any = [];
  externalRolesTableData = [];
  externalContactRoleRowIndex: number = 0;

  //externalContacts
  externalContactColumns: any[];
  externalContacts: any[] = [];
  externalContactModel: ExternalContactModel;
  externalContactRoleModel = [];
  logoList: SelectItem[];
  externalContactRowIndex: number = 0;

  displayInternalContactDialog: boolean;
  displayRoleDialog: boolean;
  displayExternalDialog: boolean;
  externalRoleDropDown: any = [];
  isEnglishLanguageSelected: boolean = false;
  isFrenchLanguageSelected: boolean = false;

  addInternalUserForm: FormGroup;
  externalContactSectionRole: FormGroup;
  externalContactForm: FormGroup;

  duplicateIntenalUsers: InternalUserModel
  clonedRolesTableData = [];
  clonedExternalTableData = [];
  isExternalContactPanelCollapsed = false;
  selectedLanguageId: number;
  defaultEnglishJson: any;
  islabelLoaded: boolean = false;
  selectedAppLanguageJson: any;
  selectedLangStatusJson: any;
  defaultEngStatusJson: any;
  selectedLangLabelJson: any;
  defaultEngLangLabelJson: any;
  loggedInUserModel: any;
  showLogs: boolean = false;
  inernalContactLog = [];

  @Output() showNextControl = new EventEmitter<string>()
  @Output() showPreviousControl = new EventEmitter<string>();
  constructor(
    private logoManagementService: LogoManagementService,
    private userService: UserService,
    private commonService: CommonService,
    private engagementMemoryService: EditEngagementMemoryServiceService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private messageService: MessageService,
    private languageService: LanguageService,
    private confirmationService: ConfirmationService
  ) {

    this.externalContacts = new Array<ExternalContactModel>();
    this.internalContactModel = new InternalUserModel();
    this.internalContactsTableData = new Array<InternalUserModel>();
    this.externalContactModel = new ExternalContactModel(0, "", "", "", "", true, '', '', 0, '')
    this.selectedLanguages = this.engagementMemoryService.getSelectedLanguages();

    this.externalContactSectionRole = this.fb.group({
      "externalRoleControls": this.fb.array([])
    });
    this.addInternalUserForm = new FormGroup({
      'internalRoleCtrl': new FormControl('', [this.internalRoleValidation()]),
      'internalUserCtrl': new FormControl('', [this.internalUserSelectValidation(), this.userDuplicateValidator(), this.reviewerValidator()]),
      'internalEmailCtrl': new FormControl('', [Validators.email]),
      'internalIsDisplayCtrl': new FormControl(false),
      'internalContactCtrl': new FormControl(this.internalContactModel.contactNumber),
      'internalFaxNo': new FormControl(this.internalContactModel.faxNumber)
    });
    this.externalContactForm = new FormGroup({
      'externalRoleCtrl': new FormControl(this.externalContactModel.selectedRole, [Validators.required]),
      'externalContactNameCtrl': new FormControl(this.externalContactModel.contactName, [Validators.required]),
      'externalEmailCtrl': new FormControl(this.externalContactModel.email, [Validators.email]),
      'externalContactPhoneCtrl': new FormControl(this.externalContactModel.phoneNumber),
      'externalContactLanguageCtrl': new FormControl(this.externalContactModel.selectedLangages, [Validators.required]),
      'externalContactLogoCtrl': new FormControl(this.externalContactModel.selectedLogo, [Validators.required]),
      'externalIsDisplayCtrl': new FormControl(true),
      'externalContactFaxNoCtrl': new FormControl(this.externalContactModel.faxNo)
    })
  }

  ngOnInit(): void {
    this.loadLanguageLabel();
    this.getExternalContactLogoList();
    this.getUserRoles();
    if (this.selectedLanguages.length > 0) {
      this.selectedLanguages.forEach(element => {
        if (element.name == "English")
          this.isEnglishLanguageSelected = true;
        this.externalRoleColumns.push({ field: element.name, header: element.name });
        this.externalContactRoleModel.push({ language: element.name, value: '' });
        (<FormArray>this.externalContactSectionRole.get('externalRoleControls')).controls.push(this.fb.group({
          'externalRoleControl': ['', [Validators.required]]
        }))
      })
      if (!this.isEnglishLanguageSelected)
        this.isFrenchLanguageSelected = false;
    }
    this.loggedInUserModel = JSON.parse(localStorage.getItem('userModel'));
  }

  internalRoleValidation(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (control.touched && control.value) {
        if (control.value?.userRoleId > 0)
          return null;
        return { 'internalUserRoleRequired': 'Select role for internal user' };
      } else if (control.value) {
        return null;
      }
      return { 'internalUserRoleRequired': 'Select internal user' };
    }
  }



  loadLanguageLabel() {
    let englishLanguageMappings, selectedLanguageMappings: any;
    let englishStatusMappings, selectedLangStatusMappings: any;
    let englishLangLabelMappings, selectedLangLabelMappings: any;

    return new Promise((resolve, reject) => {
      if (sessionStorage.getItem('selectedLanguageId')) {
        this.selectedLanguageId = 1;//JSON.parse(sessionStorage.getItem('selectedLanguageId'));
      }

      this.languageService.currentData.subscribe(data => {
        this.selectedLanguageId = data.Id
      });


      this.languageService.mySubject.subscribe((data) => {
        var languageMappings = data;
        if (languageMappings?.length > 0) {

          englishLanguageMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.EditEngagement.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          englishStatusMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.Status.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          englishLangLabelMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.Language.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          if (englishLanguageMappings?.isGlobal) {
            selectedLanguageMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.EditEngagement.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedLanguageId))[0];



            selectedLangStatusMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.Status.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedLanguageId))[0];

            selectedLangLabelMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.Language.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedLanguageId))[0];
          }
          else {
            if (Number(this.selectedLanguageId) === 2) {
              selectedLanguageMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.EditEngagement.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedLanguageId))[0];

              selectedLangStatusMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.Status.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedLanguageId))[0];

              selectedLangLabelMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.Language.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedLanguageId))[0];
            }
            else {
              selectedLanguageMappings = englishLanguageMappings;
              selectedLangStatusMappings = englishStatusMappings;
              selectedLangLabelMappings = englishLangLabelMappings;
            }
          }

          this.selectedAppLanguageJson = JSON.parse(selectedLanguageMappings.languageMappingJSON);

          this.defaultEnglishJson = JSON.parse(englishLanguageMappings.languageMappingJSON);

          this.selectedLangLabelJson = JSON.parse(selectedLangLabelMappings?.languageMappingJSON ?? englishLangLabelMappings.languageMappingJSON);
          this.defaultEngLangLabelJson = JSON.parse(englishLangLabelMappings.languageMappingJSON);

          this.selectedLangStatusJson = JSON.parse(selectedLangStatusMappings?.languageMappingJSON ?? englishStatusMappings.languageMappingJSON);
          this.defaultEngStatusJson = JSON.parse(englishStatusMappings.languageMappingJSON);

          this.internalContactColumns = [
            { field: 'roleName', header: this.labelReplacer('Role') },
            { field: 'userName', header: this.labelReplacer('Name') },
            { field: 'email', header: this.labelReplacer('EmailId') },
            { field: 'contactNumber', header: this.labelReplacer('PhoneNo') },
            { field: 'faxNumber', header: this.labelReplacer('FaxNo') },
            { field: 'isDisplay', header: this.labelReplacer('Display') }
          ];
          this.externalContactColumns = [
            { field: 'selectedRole', header: this.labelReplacer('Role') },
            { field: 'contactName', header: this.labelReplacer('Name') },
            { field: 'email', header: this.labelReplacer('EmailId') },
            { field: 'phoneNumber', header: this.labelReplacer('PhoneNo') },
            { field: 'faxNo', header: this.labelReplacer('FaxNo') },
            { field: 'language', header: this.labelReplacer('Language') },
            { field: 'logo', header: this.labelReplacer('Logo') },
            { field: 'display', header: this.labelReplacer('Display') }
          ];
          this.islabelLoaded = true;
          resolve(1);
        }
        else {

        }
      });
    })
      .catch(err => {


        console.log(err);
      });
  }

  labelReplacer(labelKey): string {
    return this.selectedAppLanguageJson[labelKey]?.trim() ? this.selectedAppLanguageJson[labelKey] ?? 'text not found' : this.defaultEnglishJson[labelKey] ?? 'text not found';
  }




  languageReplacer(labelKey): string {
    return this.selectedLangLabelJson[labelKey]?.trim() ? this.selectedLangLabelJson[labelKey] ?? 'text not found' : this.defaultEngLangLabelJson[labelKey] ?? 'text not found';
  }


  statusReplacer(labelKey): string {
    return this.selectedLangStatusJson[labelKey]?.trim() ? this.selectedLangStatusJson[labelKey] ?? 'text not found' : this.defaultEngStatusJson[labelKey] ?? 'text not found';
  }



  internalUserSelectValidation(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (control.value?.userId > 0)
        return null;
      if (control.touched && control.value) {
        if (control.value?.userId > 0)
          return null;
        return { 'internalUserRequired': 'Select internal user' };
      }
      return { 'internalUserRequired': 'Select internal user' };
    }
  }

  getExternalContactLogoList() {
    this.spinner.show();
    this.logoManagementService.GetExternalContactLogoList().subscribe((response: any) => {
      if (response.data) {
        this.logoList = response.data.map(x => ({
          label: x.logoName,
          value: x.logoIconImageDataId,
          result: 'data:image/png;base64,' + x.result
        }));
        // this.logoList = response
      }
      this.loadSavedContactDetails(this.engagementMemoryService.getEngagementId());
    });
  }

  getUserRoles() {
    this.commonService.getUserRoles().subscribe((response) => {
      if (response.responseStatus == 1) {
      } else {
        if (response && response.data.length > 0) {
          this.userRoles = response.data.filter(t => t.isDisplay)
          this.userRoles.forEach(element => {
            element.role = this.labelReplacer("RoleDropDown_" + element.userRoleId)
          });
        }
      }
    });
  }

  loadSavedContactDetails(engagementId: number) {
    this.commonService.getEngagementContactDetails(engagementId).subscribe((response) => {
      if (response.responseStatus == 1) {
        this.messageService.add({
          summary: this.labelReplacer('Erroroccuredwhileloadingcontactdetails'),
          detail: "",
          sticky: false,
          severity: 'error'
        });
      } else {
        let isEnglishSelected = false;
        if (response.data.engagementInternalContacts && response.data.engagementInternalContacts.length > 0) {
          let internalContacts = response.data.engagementInternalContacts
          for (let i = 0; i < internalContacts.length; i++) {
            internalContacts[i].userRole = { ...internalContacts[i].userRole, role: this.labelReplacer("RoleDropDown_" + internalContacts[i].userRole.userRoleId) }
            let model: InternalUserModel = {
              rowIndex: this.internalContactRowIndex,
              engagementInternalContactId: internalContacts[i].engagementInternalContactId,
              roleId: internalContacts[i].userRoleId,
              roleName: internalContacts[i].userRole.role,
              isDisplay: internalContacts[i].isDisplay,
              email: internalContacts[i].email,
              selectedRole: internalContacts[i].userRole,
              selectedUser: internalContacts[i].user,
              userName: internalContacts[i].user.firstName + " " + internalContacts[i].user.lastName,
              userId: internalContacts[i].userId,
              contactNumber: internalContacts[i].contactNumber,
              faxNumber: internalContacts[i].faxNumber,


            }
            this.internalContactsTableData.push(model);
            this.internalContactRowIndex++;
          }
        }
        if (response.data.externalRoles && response.data.externalRoles.length > 0) {
          this.isExternalContactPanelCollapsed = true;
          let externalRolesData = response.data.externalRoles;
          for (let i = 0; i < externalRolesData.length; i++) {
            externalRolesData[i].rowIndex = this.externalContactRoleRowIndex;
            this.externalRolesTableData.push({ ...externalRolesData[i] });
            this.externalContactRoleRowIndex++;
            if (externalRolesData[i].English) {
              isEnglishSelected = true;
            }
          }
          this.loadExternalRoles();
        }
        if (response.data.externalContactModels && response.data.externalContactModels.length > 0) {
          let externalContactResponse = response.data.externalContactModels;
          for (let i = 0; i < externalContactResponse.length; i++) {
            let roleModel = this.externalRolesTableData.find(t => t.ExternalRoleId == externalContactResponse[i].externalContactRoleId);
            let model = {
              rowIndex: this.externalContactRowIndex,
              externalContactId: externalContactResponse[i].externalContactId,
              externalRole: isEnglishSelected ? roleModel.English : roleModel.French,
              contactName: externalContactResponse[i].contactName,
              email: externalContactResponse[i].contactEmailId,
              phoneNumber: externalContactResponse[i].contactNumber,
              isDisplay: externalContactResponse[i].isDisplay,
              logo: externalContactResponse[i].externalContactLogo.logoName,
              faxNo: externalContactResponse[i].faxNo,
              externalRoleId: externalContactResponse[i].externalContactRoleId
            };
            model["selectedRole"] = { name: model.externalRole, };

            // model["selectedLogo"] = new LogoValue(externalContactResponse[i].externalContactLogo.logoIconImageDataId,
            // model["selectedLogo"] = {
            //   label: externalContactResponse[i].externalContactLogo.logoName,
            //   value: externalContactResponse[i].externalContactLogo.logoIconImageDataId
            // }
            model["selectedLogo"] = externalContactResponse[i].externalContactLogo.logoIconImageDataId;
            model["language"] = "";
            model["selectedLangages"] = [];
            externalContactResponse[i].languageId.split(',').forEach(element => {
              let lan = this.selectedLanguages.find(t => t.languageId == element);
              if(lan != undefined){
                model["language"] += lan.name + " ";
                model["selectedLangages"].push({ ...lan });
              }
            })
            model["language"] = model["language"].trim();
            this.externalContacts.push(model);
            this.externalContactRowIndex++;
          }
        }
      }
      this.spinner.hide();
    })
  }

  loadContactDetails() {
    if (this.engagementMemoryService.getInteralContact().length > 0)
      this.internalContactsTableData = [...this.engagementMemoryService.getInteralContact()];
    if (this.engagementMemoryService.getExternalRole().length > 0) {
      this.externalRolesTableData = this.engagementMemoryService.getExternalRole();
    }
    if (this.engagementMemoryService.getExternalContacts().length > 0) {
      this.externalContacts = this.engagementMemoryService.getExternalContacts();
    }
  }

  getUserByRole(event) {
    if (event && event.value) {
      this.internalContactModel.roleId = event.value.userRoleId;
      this.internalContactModel.roleName = event.value.role;
      this.internalContactModel.selectedUser = {};
      this.internalContactModel.email = "";
      this.getUserList(event.value.userRoleId)
    }
  }

  getUserList(roleId) {
    this.spinner.show();
    this.userService.getUserListByRoleId(roleId).subscribe((response: any) => {
      if (response.responseStatus == 1) {

      } else {
        if (response.data && response.data.length > 0) {
          this.userDropDownData = response.data.map(t => ({
            userName: t.firstName + " " + t.lastName,
            userId: t.userId,
            emailId: t.emailId
          }));
          //this.userDropDownData = this.userDropDownData.filter(t => t.userId)
        }
        else {
          this.userDropDownData = [];
        }
      }
      this.spinner.hide();
    });
  }

  onNameSelection(event) {
    if (event.value) {
      this.internalContactModel.userId = event.value.userId;
      this.internalContactModel.userName = event.value.userName;
      this.internalContactModel.email = event.value.emailId;
    }
  }

  resetAddInternalContact() {
    this.addInternalUserForm.reset();
    this.userDropDownData = [];
    this.internalContactModel.rowIndex = 0;
    this.internalContactModel.roleId = 0;
    this.internalContactModel.roleName = "";
    this.internalContactModel.userId = 0;
    this.internalContactModel.userName = "";
    this.internalContactModel.email = "";
    this.internalContactModel.isDisplay = false;
    this.internalContactModel.selectedRole = {};
    this.internalContactModel.selectedUser = {};
    this.internalContactModel.engagementInternalContactId = 0;
    this.isSaveButtonEnable = true;
    this.internalContactModel.contactNumber = "";
    this.editInternalContactRowIdex = -1;
  }

  showInternalContactDialogToAdd() {
    this.resetAddInternalContact();
    this.displayInternalContactDialog = true;
  }

  AddInternalContact() {
    if (!this.addInternalUserForm.invalid) {
      this.spinner.show();
      let internalContactModel = {
        'EngagementInternalContactId': 0,
        'EngagementId': this.engagementMemoryService.getEngagementId(),
        'UserId': this.internalContactModel.userId,
        'UserRoleId': this.internalContactModel.roleId,
        'IsDisplay': this.internalContactModel.isDisplay,
        'Email': this.internalContactModel.email,
        'ContactNumber': this.internalContactModel.contactNumber,
        'FaxNumber': this.internalContactModel.faxNumber
      };
      this.commonService.saveOrUpdateInternalUser(internalContactModel).subscribe((response) => {
        if (response.responseStatus == 1) {
          this.messageService.add({
            summary: this.labelReplacer('Internalcontactaddedsuccessfully'),
            detail: "",
            sticky: false,
            severity: 'success'
          });
        } else {
          if (response.data) {
            this.internalContactModel.rowIndex = this.internalContactRowIndex;
            this.internalContactRowIndex++;
            let model = { ...this.internalContactModel }
            model.engagementInternalContactId = response.data.engagementInternalContactId;
            this.internalContactsTableData.push(model);
            this.displayInternalContactDialog = false;
            this.internalContactsTableData.sort((a, b) => {
              if (a.userName > b.userName)
                return 1;
              if (b.userName > a.userName)
                return -1
              return 0;
            })
          }
        }
        this.spinner.hide();
      })

    } else {
      this.addInternalUserForm.markAllAsTouched();
    }
  }

  onInternalContactEditInit(rowData) {
    this.spinner.show();
    this.resetAddInternalContact();
    this.getUserList(rowData.roleId);
    this.displayInternalContactDialog = true;
    setTimeout(() => {
      this.internalContactModel = { ...rowData };
      this.clonedInternalContact = { ...rowData };
      this.editInternalContactRowIdex = rowData.rowIndex;
      this.spinner.hide();
    }, 1000)

    this.isSaveButtonEnable = false;
  }


  removeInternalUser(rowData: InternalUserModel) {

    let exceptionModel = this.validateInternalUserEdit(rowData)
    if (exceptionModel.isValid) {
      this.confirmationService.confirm({
        message: this.labelReplacer('DeleteContactConfirmationMessage'),
        accept: () => {
          this.spinner.show();
          this.commonService.deleteInternalUser(rowData.engagementInternalContactId).subscribe((response) => {
            if (response.responseStatus == 1) {
              // alert("Error occured while deleteing internal contact");
              this.messageService.add({
                summary: this.labelReplacer('Erroroccuredwhiledeleteinginternalcontact'),
                detail: "",
                sticky: false,
                severity: 'error'
              });
            } else {
              this.internalContactsTableData = this.internalContactsTableData.filter(t => t.rowIndex != rowData.rowIndex);
              this.messageService.add({
                summary: this.labelReplacer('Internalcontactdeletedsuccessfully'),
                detail: "",
                sticky: false,
                severity: 'success'
              });
            }
            this.spinner.hide();
          });
        }
      });

    } else {
      this.messageService.add({
        summary: 'Validation failed',
        detail: exceptionModel.exceptionMessages,
        sticky: false,
        severity: 'error'
      });
    }
  }

  changesUserSelected(event, rowData: InternalUserModel) {
    this.displayInternalUserDropDown = false
    this.getUserByRole(event);
    let data = this.internalContactsTableData.find(t => t.rowIndex == rowData.rowIndex);
    rowData.email = "";
    rowData.selectedUser = { userName: null, userId: null };
    rowData.userName = "";
    rowData.userId = 0;
    this.displayInternalUserDropDown = true;
  }

  validateInternalUserEdit(rowData: InternalUserModel): { isValid: boolean, exceptionMessages: string } {
    let exceptionModel = { isValid: true, exceptionMessages: '' };
    if (rowData.roleId == 1) {
      let contact = this.internalContactsTableData.find(t => t.rowIndex != rowData.rowIndex && t.roleId == 1);
      if (!contact) {
        exceptionModel.isValid = false;
        exceptionModel.exceptionMessages += 'There should be alteast one owner\n';
      }
    }
    if (rowData.roleId == 2) {
      let contact = this.internalContactsTableData.find(t => t.rowIndex != rowData.rowIndex && t.roleId == 2);
      if (!contact) {
        exceptionModel.isValid = false;
        exceptionModel.exceptionMessages += 'There should be alteast one reviewer\n';
      }
    }

    return exceptionModel;
  }


  updateInternalContact() {
    if (!this.addInternalUserForm.invalid) {
      let exceptionModel: any = null;
      let x = this.clonedInternalContact
      if ((this.clonedInternalContact.roleName == "Owner" || this.clonedInternalContact.roleName == "Reviewer") && this.clonedInternalContact.roleName != this.internalContactModel.roleName)
        exceptionModel = this.validateInternalUserEdit(this.clonedInternalContact);
      if (!exceptionModel || exceptionModel?.isValid) {
        let internalContactModel = {
          'EngagementInternalContactId': this.internalContactModel.engagementInternalContactId,
          'EngagementId': this.engagementMemoryService.getEngagementId(),
          'UserId': this.internalContactModel.userId,
          'UserRoleId': this.internalContactModel.roleId,
          'IsDisplay': this.internalContactModel.isDisplay,
          'Email': this.internalContactModel.email,
          'ContactNumber': this.internalContactModel.contactNumber,
          'FaxNumber': this.internalContactModel.faxNumber
        };
        this.commonService.saveOrUpdateInternalUser(internalContactModel).subscribe((response) => {
          if (response.responseStatus == 1) {
            //  alert("Error occured while updaing internal contact");
            this.messageService.add({
              summary: this.labelReplacer('Erroroccuredwhileupdainginternalcontact'),
              detail: "",
              sticky: false,
              severity: 'error'
            });
          } else {
            if (response.data) {
              let index = this.internalContactsTableData.findIndex(t => t.rowIndex == this.internalContactModel.rowIndex)
              this.internalContactsTableData[index] = { ...this.internalContactModel };
              this.displayInternalContactDialog = false;
            }
          }
        })
      } else {
        this.messageService.add({
          summary: 'Validation failed',
          detail: exceptionModel.exceptionMessages,
          sticky: false,
          severity: 'error'
        });
      }
    } else {
      this.addInternalUserForm.markAllAsTouched();
    }
  }

  resetRolesSection() {
    this.externalContactSectionRole.get('externalRoleControls').reset();
    (<FormArray>this.externalContactSectionRole.get('externalRoleControls')).controls.forEach((element, index) => {
      element.setValue({ 'externalRoleControl': '' });
    });
  }

  showDialogToAddRole() {
    this.resetRolesSection();
    this.displayRoleDialog = true;
  }

  saveRole() {
    let isValid = true;
    (<FormArray>this.externalContactSectionRole.get('externalRoleControls')).controls.forEach(element => {
      if (element.invalid) {
        isValid = false
        return;
      }
    })
    if (isValid) {
      this.spinner.show();
      let obj: any = {};
      obj["rowIndex"] = this.externalContactRoleRowIndex;
      (<FormArray>this.externalContactSectionRole.get('externalRoleControls')).controls.forEach((element, index) => {
        obj[this.externalContactRoleModel[index].language] = element.value.externalRoleControl;
      });
      obj['ExternalRoleId'] = 0;
      obj['EngagementId'] = this.engagementMemoryService.getEngagementId();
      this.commonService.saveExternalRoles(obj).subscribe((response) => {
        if (response.responseStatus == 1) {
          // alert("Error occured while deleting external role");
          this.messageService.add({
            summary: this.labelReplacer('Erroroccuredwhiledeletingexternalrole'),
            detail: "",
            sticky: false,
            severity: 'error'
          });
        } else {
          obj.ExternalRoleId = response.data;
          this.externalRolesTableData.push(obj);
          this.externalContactRoleRowIndex++;
          this.loadExternalRoles();
          this.displayRoleDialog = false;
        }
        this.spinner.hide();
      })

    } else {
      this.externalContactSectionRole.get('externalRoleControls').markAllAsTouched();
    }
  }

  onRowRoleEditInit(rowData) {
    this.clonedRolesTableData.push({ ...rowData });
  }

  onRowRoleEditSave(rowData, index) {
    let validationModel = this.validateExternalRoles(rowData, index)
    if (validationModel.isValid) {
      this.spinner.show();
      this.commonService.updateExternalRoles(rowData).subscribe((response) => {
        if (response.responseStatus == 1) {
          //alert("Error occured while updating external role");
          this.messageService.add({
            summary: this.labelReplacer('Erroroccuredwhileupdatingexternalrole'),
            detail: "",
            sticky: false,
            severity: 'error'
          });
        } else {
          let index = this.clonedRolesTableData.findIndex(t => t.rowIndex == rowData.rowIndex);
          this.loadExternalRoles();
          this.updateExternalContactRole(this.clonedRolesTableData[index], rowData);
          delete this.clonedRolesTableData[index];
        }
        this.spinner.hide();
      })
    }
    else {
      // alert(validationModel.exceptionMessages);
      this.messageService.add({
        summary: "Validation failed.",
        detail: validationModel.exceptionMessages,
        sticky: false,
        severity: 'error'
      });
    }
  }

  validateExternalRoles(rowData, index): { isValid: boolean, exceptionMessages: string } {
    index++;
    let exceptionModel = { isValid: true, exceptionMessages: "" }
    this.selectedLanguages.forEach(element => {
      if (!rowData[element.name]) {
        exceptionModel.isValid = false;
        exceptionModel.exceptionMessages += "Row " + index + ": Please Enter Role for " + element.name + '\n';
      }
    })
    return exceptionModel;
  }

  onRowRoleEditCancel(rowData) {
    let index = this.clonedRolesTableData.findIndex(t => t.rowIndex == rowData.rowIndex);
    let intialIndex = this.externalRolesTableData.findIndex(t => t.rowIndex == rowData.rowIndex);
    this.externalRolesTableData[intialIndex] = this.clonedRolesTableData[index]
    delete this.clonedRolesTableData[index];
  }


  onDeleteRole(rowData) {
    if (this.isValidExternalRoleDelete(rowData.ExternalRoleId)) {
      this.spinner.show();
      this.commonService.deleteExternalRole(rowData.ExternalRoleId).subscribe((response) => {
        if (response.responseStatus == 1) {
          //alert("Error occured while updating external role");
          this.messageService.add({
            summary: this.labelReplacer('Erroroccuredwhileupdatingexternalrole'),
            detail: "",
            sticky: false,
            severity: 'error'
          });
        } else {
          this.externalRolesTableData = this.externalRolesTableData.filter(t => t.rowIndex != rowData.rowIndex);
          this.clonedRolesTableData = this.clonedRolesTableData.filter(t => t.rowIndex != rowData.rowIndex);
        }
        this.spinner.hide();
      })
    } else {
      this.messageService.add({
        summary: this.labelReplacer('DeleteRelatedExternalContacts'),
        detail: "",
        sticky: false,
        severity: 'error'
      });
    }
  }

  resetExternalContactUser() {
    this.externalContactForm.reset();
    this.externalContactModel = new ExternalContactModel(0, "", "", "", "", true, '', '', 0, "");
    this.externalContactForm.get('externalIsDisplayCtrl').setValue(true);
  }

  saveExternalUser() {
    if (!this.externalContactForm.invalid) {
      this.externalContactModel.rowIndex = this.externalContactRowIndex;
      this.externalContactModel.externalRole = this.externalContactModel.selectedRole.name;
      this.externalContactModel.externalRoleId = this.externalContactModel.selectedRole.value;
      this.externalContactModel.selectedLangages.forEach(element => {
        this.externalContactModel.language += element.name + " "
      });
      this.externalContactModel.language = this.externalContactModel.language.trim();
      let logo = this.logoList.find((t) => t.value == this.externalContactModel.selectedLogo)
      this.externalContactModel.logo = logo.label;
      let requestModel = { ...this.externalContactModel };
      requestModel.selectedLogo = {
        value: requestModel.selectedLogo,
      }
      this.spinner.show();
      this.commonService.saveOrUpdateExternalContact({ ...requestModel, engagementId: this.engagementMemoryService.getEngagementId() }).subscribe((response) => {
        if (response.responseStatus == 1) {
          this.messageService.add({
            summary: this.labelReplacer("Erroroccuredwhileaddingexternalconatct"),
            detail: "",
            sticky: false,
            severity: 'error'
          });
        } else {
          this.messageService.add({
            summary: this.labelReplacer('Externalcontactaddedsuccessfully'),
            detail: "",
            sticky: false,
            severity: 'success'
          });
          this.externalContactModel.externalContactId = response.data;
          this.externalContacts.push({ ...this.externalContactModel });
          this.externalContactRowIndex++;
          this.displayExternalDialog = false;
        }
        this.spinner.hide();
      })
    } else {
      this.externalContactForm.markAllAsTouched();
    }
  }

  showDialogToAddExternal() {
    if (this.externalRolesTableData.length > 0) {
      this.resetExternalContactUser();
      this.loadExternalRoles();
      this.displayExternalDialog = true;
    }
  }

  loadExternalRoles() {
    let roles = [];
    if (this.isEnglishLanguageSelected) {
      roles = this.externalRolesTableData.map(t => ({ name: t.English, value: t.ExternalRoleId }))
    } else if (this.isFrenchLanguageSelected) {
      roles = this.externalRolesTableData.map(t => ({ name: t.French, value: t.ExternalRoleId }))
    }
    this.externalRoleDropDown = roles;
  }


  onRowEditInitExternal(rowData: ExternalContactModel) {
    this.clonedExternalTableData.push({ ...rowData });
  }

  onRowEditSaveExternal(rowData: ExternalContactModel) {
    let validationModel = this.validateExternalContactEdit(rowData);
    if (validationModel.isValid) {
      rowData.externalRole = rowData.selectedRole.name;
      rowData.language = "";
      rowData.selectedLangages.forEach(element => {
        rowData.language += element.name + " "
      });
      // rowData.logo = rowData.selectedLogo;
      rowData.language = rowData.language.trim();
      let logo = this.logoList.find((t) => t.value == rowData.selectedLogo)
      rowData.logo = logo.label;
      let requestModel = { ...rowData };
      requestModel.selectedLogo = {
        value: rowData.selectedLogo,
      }
      this.spinner.show();
      this.commonService.saveOrUpdateExternalContact({ ...requestModel, engagementId: this.engagementMemoryService.getEngagementId() }).subscribe((response) => {
        if (response.responseStatus == 1) {
          //alert("Error occured while updating external contact");
          this.messageService.add({
            summary: this.labelReplacer('Erroroccuredwhileupdatingexternalcontact'),
            detail: "",
            sticky: false,
            severity: 'error'
          });
        } else {
          if (this.clonedExternalTableData && this.clonedExternalTableData.length > 0 && rowData.rowIndex) {
            let tempIndex = this.clonedExternalTableData.findIndex((t) => {
              t.rowIndex == rowData.rowIndex
            });
            delete this.clonedExternalTableData[tempIndex];
          }
          this.messageService.add({
            summary: this.labelReplacer('Externalcontactupdatedsuccessfully'),
            detail: "",
            sticky: false,
            severity: 'success'
          });
        }
        this.spinner.hide();
      })
    }
    else {
      // alert(validationModel.exceptionMessages);
      this.messageService.add({
        summary: "Validation failed",
        detail: validationModel.exceptionMessages,
        sticky: false,
        severity: 'error'
      })
    }
  }

  validateExternalContactEdit(rowData: ExternalContactModel): { isValid: boolean, exceptionMessages: string } {
    let exceptionModel = { isValid: true, exceptionMessages: "" };
    if (rowData.contactName == "") {
      exceptionModel.isValid = false;
      exceptionModel.exceptionMessages += this.labelReplacer('Entercontactname') + "\n";
    }
    if (rowData.email != '' && !rowData.email.match(/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})+$/gm)) {
      exceptionModel.isValid = false;
      exceptionModel.exceptionMessages += this.labelReplacer('Entervalidemail') + "\n";
    }
    // if (rowData.phoneNumber != "" && !rowData.phoneNumber.match(/^[0-9-+]*$/im)) {
    //   exceptionModel.isValid = false;
    //   exceptionModel.exceptionMessages += this.labelReplacer('Entervalidphonenumber') + "\n";
    // }
    // if (rowData.faxNo != "" && !rowData.faxNo.match(/^[0-9-+]*$/im)) {
    //   exceptionModel.isValid = false;
    //   exceptionModel.exceptionMessages += this.labelReplacer('Invalidfaxnumber') + "\n";
    // }
    if (!rowData.selectedLangages || rowData.selectedLangages.length == 0) {
      exceptionModel.isValid = false;
      exceptionModel.exceptionMessages += this.labelReplacer('Pleasechoosethelanguages') + "\n";
    }
    return exceptionModel;
  }

  onRowEditCancelExternal(rowData: ExternalContactModel, ri) {
    let tempIndex = this.clonedExternalTableData.findIndex(t => t.rowIndex == rowData.rowIndex);
    for (let i = 0; i < this.externalContacts.length; i++) {
      if (this.externalContacts[i].rowIndex == rowData.rowIndex) {
        this.externalContacts[i] = this.clonedExternalTableData[tempIndex];
        break;
      }
    }
    delete this.clonedExternalTableData[tempIndex];
  }

  onDeleteExternalUser(rowData: ExternalContactModel) {
    this.commonService.deleteExternalContact(rowData.externalContactId).subscribe((response) => {
      if (response.responseStatus == 1) {
        // alert("Error occured while updating external contact");
        this.messageService.add({
          summary: this.labelReplacer('Erroroccuredwhileupdatingexternalcontact'),
          detail: "",
          sticky: false,
          severity: 'error'
        });
      } else {
        this.externalContacts = this.externalContacts.filter(t => t.rowIndex != rowData.rowIndex);
      }
    })

  }

  updateExternalContactRole(clonedData, rowData) {
    if (this.isEnglishLanguageSelected) {
      this.externalContacts.forEach(ele => {
        if (ele.externalRole == clonedData.English) {
          ele.externalRole = rowData.English;
          ele.selectedRole = { 'name': rowData.English };
        }
      })
    } else if (this.isFrenchLanguageSelected) {
      this.externalContacts.forEach(ele => {
        if (ele.externalRole == clonedData.French) {
          ele.externalRole = rowData.French;
          ele.selectedRole.name = { 'name': rowData.French };
        }
      })
    }
  }

  userDuplicateValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (control.touched || control.dirty)
        if (control.value.userId && control.value?.userId > 0) {
          let isUserExists = this.internalContactsTableData.findIndex(t => t.userId == control.value.userId && t.rowIndex != this.editInternalContactRowIdex)
          if (isUserExists > -1)
            return { 'userExits': 'Jurisdiction is required' };
        }
      return null
    }
  }

  reviewerValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (control.touched || control.dirty)
        if (control.value.userId && control.value?.userId > 0) {
          if (this.internalContactModel.selectedRole.userRoleId == 2 && this.loggedInUserModel.rankCode > 21 && !this.loggedInUserModel.isAdmin && this.loggedInUserModel.userId == control.value.userId) {
            return { 'unauthorizedSelection': true }
          }
        }
      return null
    }
  }

  showInternalContactLogs() {
    this.showLogs = true;
    this.spinner.show();
    this.commonService.getEngagementInternalContactHistory(this.engagementMemoryService.getEngagementId())
      .subscribe((res: any) => {
        if (res.responseStatus == 1) {

        } else {
          this.inernalContactLog = res.data;
        }
        this.spinner.hide();
      });
  }

  isValidExternalRoleDelete(externalRoleId): boolean {
    let index = this.externalContacts.findIndex(t => t.externalRoleId == externalRoleId)
    if (index > -1) {
      return false;
    } else {
      return true;
    }
  }
}

export class InternalUserModel {
  rowIndex: number;
  roleId: number;
  roleName: string;
  userId: number;
  email: string;
  userName: string;
  isDisplay: boolean
  selectedRole: any;
  selectedUser: any;
  engagementInternalContactId: number;
  contactNumber: any;
  faxNumber: string;
  constructor() {
    this.roleId = 0;
    this.userId = 0;
    this.email = "";
    this.userName = "";
    this.isDisplay = false;
    this.roleName = "";
    this.selectedRole = "";
    this.selectedUser = "";
    this.rowIndex = 0;
    this.engagementInternalContactId = 0;
    this.contactNumber = "";
    this.faxNumber = "";
  }
}

export class ExternalContactModel {
  rowIndex: number;
  externalRole: string;
  contactName: string;
  email: string;
  language: string;
  phoneNumber: string;
  isDisplay: boolean;
  logo: string;
  selectedRole: any;
  selectedLangages: any;
  selectedLogo: any;
  externalContactId: number
  faxNo: string;
  externalRoleId: number;
  constructor(rowIndex: number, externalRole: string, contactName: string, email: string, phoneNumber: string, isDisplay: boolean, language: string, logo: string, externalContactId: number, faxNo: string) {
    this.rowIndex = rowIndex;
    this.externalRole = externalRole;
    this.contactName = contactName;
    this.email = email;
    this.phoneNumber = phoneNumber;
    this.isDisplay = isDisplay;
    this.selectedRole = '';
    this.selectedLangages = '';
    this.selectedLogo = ''
    this.language = language;
    this.logo = logo;
    this.externalContactId = externalContactId;
    this.faxNo = faxNo;
  }
}
